import { Helmet } from 'react-helmet';

interface IProps {
  title?: string;
  matomoTag?: string;
}

const MetaDatas = (props: IProps) => (
  <Helmet>
    <meta charSet="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="description" content="Application " />
    <link rel="manifest" id="react-app-manifest" />
    <link
      href="https://fonts.googleapis.com/css2?family=Mulish:wght@200;400;700&family=Poppins:wght@200;500;600;700&display=swap"
      rel="stylesheet"
    />{' '}
    <link rel="stylesheet" href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css" />
    <link rel="icon" id="icon" />
    <link rel="apple-touch-icon" id="apple-touch-icon" />
    {/* <link rel="icon" id="icon-192" sizes="192x192" href={process.env.PUBLIC_URL + '/logo192.png'} />
    <link rel="apple-touch-startup-image" id="apple-touch-startup" href={process.env.PUBLIC_URL + '/logo192.png'} />
    <link rel="apple-touch-icon" id="apple-touch-icon" href={process.env.PUBLIC_URL + '/logo192.png'} />
    <link
      rel="apple-touch-icon"
      id="apple-touch-icon-152"
      sizes="152x152"
      href={process.env.PUBLIC_URL + '/logo192.png'}
    />
    <link
      rel="apple-touch-icon"
      id="apple-touch-icon-167"
      sizes="167x167"
      href={process.env.PUBLIC_URL + '/logo192.png'}
    />
    <link
      rel="apple-touch-icon"
      id="apple-touch-icon-180"
      sizes="180x180"
      href={process.env.PUBLIC_URL + '/logo192.png'}
    /> */}
    <meta name="theme-color" content="#ff4137" id="theme-color" />
    <meta name="apple-mobile-web-app-status-bar-style" content="#ff4137" id="theme-color-ios" />
    <meta name="description" content="Saga en ligne" id="description" />
    <title id="title">{props.title || 'Carte Privilège'}</title>
    {props.matomoTag && sessionStorage.getItem('matomoTrackingEnabled') === 'true' && (
      <script type="text/javascript">
        {`
        window._paq = window._paq || [];
        window._paq.push(['trackPageView']);
        window._paq.push(['enableLinkTracking']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src='https://webstat.besse.fr/js/container_${props.matomoTag}.js'; s.parentNode.insertBefore(g,s);
      `}
      </script>
    )}
  </Helmet>
);
export default MetaDatas;
